﻿import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'formatdateasname',
    pure: true
})
@Injectable()
export class FormatDateAsNamePipe implements PipeTransform {
    transform(dateStr: any): string {

        var nowDate = this.withoutTime(new Date());
        var compareDate = this.withoutTime(new Date(dateStr));

        var daysBetween = this.convertMS(compareDate.getTime() - nowDate.getTime());

        if (daysBetween === 0) {
            return "I dag";
        }
        else if (daysBetween === 1) {
            return "I morgen";
        }
        else if (daysBetween === 2) {
            return "I overmorgen";
        }

        return daysBetween + " dage";

    }


    withoutTime(date: Date): Date {
        date.setMinutes(0);
        date.setHours(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        return date;
    }

    convertMS(ms: number) {
        var d, h, m, s;
        s = Math.floor(ms / 1000);
        m = Math.floor(s / 60);
        s = s % 60;
        h = Math.floor(m / 60);
        m = m % 60;
        d = Math.floor(h / 24);
        h = h % 24;
        return d;
    };

}